import * as types from "../constants/util-types";

const utilReducer = (state = {}, action) => {
  switch (action.type) {
    case types.SEARCH_ITEMS:
      return { results: action.payload };
    case types.GET_CATEGORIES:
      return { categories: action.payload };
    default:
      return state;
  }
};

export default utilReducer;
